import { render, staticRenderFns } from "./ABMPersonal.vue?vue&type=template&id=1986b2a7&"
import script from "./ABMPersonal.vue?vue&type=script&lang=js&"
export * from "./ABMPersonal.vue?vue&type=script&lang=js&"
import style0 from "./ABMPersonal.vue?vue&type=style&index=0&id=1986b2a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports